import React from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const PlaceholderPage = ({ title = 'Logged in to Magellan' }) => {
  return (
    <Box sx={{ margin: '72px 30px 30px' }}>
      <Typography variant="h4">{title}</Typography>
    </Box>
  );
};

PlaceholderPage.propTypes = {
  title: PropTypes.string,
};

PlaceholderPage.defaultProps = {
  title: 'Logged in to Magellan',
};

export default PlaceholderPage;
